module.exports = __webpack_public_path__ + "img/65731.7480463d.png";